// imports
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: `"Source Sans Pro Web", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif`,
  },
});

export default theme;
